export class ServiceRequestSet {
    id = null;
    name = null;
    code = null;
    description = null;
    members = null;
    service = null;
    healthCareService = null;
    drugs = null;
    supplies = null;
    isUsing = true;
}